"use client";

import "./footer.css";
import { FaFacebookF, FaYoutube } from "react-icons/fa";
import { useLocation, Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  const { pathname } = useLocation();
  const isLogin = pathname === "/login";
  const isSignup = pathname === "/signup";
  const fixedClass = isLogin || isSignup ? "fixed" : "";
  return (
    <>
      {/* Desktop footer ONLY (hidden on mobile) */}
      <footer
        id="site-footer"
        className="hidden md:block bg-black text-gray-300 px-16 lg:px-20 py-8 md:py-10"
      >
        {/* mobile: row + wrap; desktop: same spacing/layout */}
        <div className="w-full grid grid-cols-2 gap-x-2 gap-y-3 md:flex md:flex-row md:justify-between md:gap-10">
          {/* LEFT: Brand + text (desktop unchanged) */}
          <div className="col-span-1 md:w-1/2 flex flex-col items-start text-left gap-2 md:gap-4 left-col">
            <div className="hidden md:flex items-center gap-2">
              <span className="text-white font-normal md:text-[27px] md:mr-[10px]">
                KHANQATULLAH
              </span>
              <span className="md:text-[16px] text-white font-[PalatinoArabic]">
                خانقةاللّٰہِ
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-8 logo-row mt-4">
              <img
                id="footerLogo"
                src="/images/logoImage.png"
                alt="Logo"
                width={100}
                height={100}
                className="object-contain"
              />

              <div className="text-left">
                {/* long blurb only on desktop */}
                <p className="hidden md:block text-[16px] leading-relaxed w-full">
                  Khanqatullah is a private platform dedicated to authentic
                  Islamic learning. Access to live streams, audio lectures, and
                  resources is restricted to verified members approved by the
                  administration.
                </p>
              </div>
            </div>
          </div>

          {/* MIDDLE: Links — hidden on mobile, desktop unchanged */}
          <div className="hidden md:flex text-[16px] md:text-[16px] flex-col items-center md:items-start gap-2">
            <a
              href="#"
              className="hover:text-gray-300 text-white no-underline font-[GaretRegular]"
            >
              Home
            </a>
            <a
              href="#"
              className="hover:text-gray-300 text-white no-underline font-[GaretRegular]"
            >
              About Us
            </a>
            <a
              href="#"
              className="hover:text-gray-300 text-white no-underline font-[GaretRegular]"
            >
              Lectures
            </a>
            <a
              href=""
              className="hover:text-gray-300 text-white no-underline font-[GaretRegular]"
            >
              Live Streaming
            </a>
            <Link
              to="/privacy"
              className="hover:text-gray-300 text-white no-underline font-manrope"
            >
              Privacy Policy
            </Link>
            <a
              href="/terms"
              className="hover:text-gray-300 text-white no-underline font-manrope"
            >
              Terms &amp; Conditions
            </a>
          </div>

          {/* RIGHT: Contact + socials */}
          <div className="col-span-1 md:w-auto flex flex-col items-end md:items-start text-right md:text-left gap-4 text-sm md:text-[16px]">
            <div className="md:text-left">
              <span className="font-semibold text-white mb-1 font-manrope text-base md:text-[16px]">
                Contact Us
              </span>
              <p className="text-sm md:text-[16px] mt-[7px]">
                info@khanqatullah.com
              </p>
            </div>

            <div className="flex gap-2.5 md:gap-4 mb-1 md:mb-5 justify-end md:justify-start">
              <a
                href="#"
                className="bg-[#545454] p-2.5 md:p-3 rounded-lg text-[#aaaaaa]"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="#"
                className="bg-[#545454] p-2.5 md:p-3 rounded-lg text-[#aaaaaa]"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
            </div>

            <p className="text-xs md:text-[16px] mt-1 md:mt-0">
              Khanqatullah (c) {year}
            </p>
          </div>
        </div>
      </footer>

      {/* Mobile-only fixed footer bar */}
      <footer
        id="mobile-footer"
        className={`${fixedClass} md:hidden bg-black text-gray-300 z-n1`}
      >
        <div className="h-full max-w-[1600px] mx-auto px-4 py-0.5 flex items-center justify-between">
          <div className="flex gap-2.5 items-center justify-between">
            <img
              id="mobileFooterLogo"
              src="/images/logoImage.png"
              alt="Logo"
              className="h-12  w-auto" // ← change size here (h-5, h-6, h-8, etc.)
            />
            <div className="flex flex-col text-[8px] gap-0.5 mt-2.5 text-white font-manrope">
              <Link
                to="/privacy"
                className="block no-underline leading-tight hover:text-white/80"
              >
                Privacy Policy
              </Link>

              <a
                href="/terms"
                className="block no-underline leading-tight hover:text-white/80"
              >
                Terms &amp; Conditions
              </a>

              <p className="block leading-tight">info@khanqatullah.com</p>
            </div>
          </div>
          {/* Right side: icons on top, copyright below */}
          <div className="flex flex-col items-end gap-1 mt-3 py-2 my-[6px]">
            <div className="flex gap-2.5">
              <a
                href="#"
                aria-label="Facebook"
                className="bg-[#545454] p-2 rounded-md text-[#aaaaaa] leading-none"
              >
                <FaFacebookF size={10} />
              </a>
              <a
                href="#"
                aria-label="YouTube"
                className="bg-[#545454] p-2 rounded-md text-[#aaaaaa]"
              >
                <FaYoutube size={10} />
              </a>
            </div>
            <p className="text-[8px] leading-none text-[#ffffff]">
              Khanqatullah © {year}
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
